<script>
export default {
    name: "PrintPrescription",

    data() {

        return {
            patient: {},
            prescriptions: [],
            request:{},
        };
    },

    mounted() {

        Promise.all([ this.fetchPatient(), this.fetchMFRequest(), ]).then(() => {
            window.print();
            window.onafterprint = () => window.close();
            window.oncancel = () => window.close();
        }).catch(() => {});
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(({ data }) => {
                this.patient = data.length ? data[0] : {};
            }).catch(() => {});
        },
        fetchMFRequest() {

let url = `MedicalFile/GetSpecificPatientConsultation`;
    url += `?ConsultationsID=${this.$route.params.consultantrequestId}`;
   
    return this.$http.get(url).then(({ data }) => {
                this.request = data.length ? data[0] : {};
            }).catch(() => {});
},
        fetchPrescriptions() {
            let url = `MedicalFile/GetPatientPrescriptionOrdersforGivenDate`;
                url += `?PatientId=${this.$route.params.patientID}`;
                url += `&VisitNo=${this.$route.params.visitNo}`;
                //consultantrequestId
                url += `&OrderDate=${this.$moment().format(`YYYY-MM-DD`)}`;

            return this.$http.get(url).then(({ data }) => {
                this.prescriptions = data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
        <h5 class="w-full font-bold text-center">PATIENT CONSULTANT REQUEST </h5>
        <div class="w-full flex flex-wrap max-h-8 overflow-auto border-b-2 border-t-2 border-gray-800" >
                              <div class="md:w-1/3 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Name: {{$route.params.consultantrequestId}}
                                        <span class="font-bold">{{ patient.names }}</span></h5>
                              </div>
                              
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">IPFile NO: 
                                        <span class="font-bold">{{ patient.ipfileno }}</span></h5>
                              </div>
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">OPFile NO: 
                                        <span class="font-bold">{{ patient.opfileno }}</span></h5>
                              </div>
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">MRN: 
                                         <span class="font-bold">{{ patient.patienT_ID }}</span></h5>
                              </div>
                             <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Age: 
                                         <span class="font-bold">{{ patient.age }} Yr(s)</span></h5>
                              </div> 
                          </div>
       <h5 class="w-full font-bold text-center">REQUEST DETAILS </h5>
       <!-- <tail-stamp></tail-stamp> -->
       <div class="w-full flex flex-wrap max-h-8 overflow-auto border-b-2 border-t-2 border-gray-800" >
                              <div class="md:w-1/4 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Clinic:  
                                        <span class="font-bold">{{ request.clinic }}</span></h5>
                              </div>
                              
                              <div class="md:w-1/4 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Consultant: 
                                        <span class="font-bold">{{ request.physician }}</span></h5>
                              </div>
                              <div class="md:w-1/4 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Date: 
                                        <span class="font-bold">{{ request.txnDate | dateFormat }}</span></h5>
                              </div>
                              <div class="md:w-1/4 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Recorded By: 
                                         <span class="font-bold">{{ request.userName||"-" }}</span></h5>
                              </div>
                              
                          </div>
                          <div class="w-full overflow-visible">
            <!-- <div class="md:w-full sm:w-full p-tiny">
                
              <p v-html="request.description"></p>
            
                              </div> -->
                              
                          
        </div>
        
        <div class="w-full flex flex-wrap p-1 my-1 border-t-2 border-gray-800">
            
            <div class="w-full p-1 text-right">
                <h5 class="text-sm font-bold">Printed By: {{ $root.username }}</h5>
            </div>
        </div>
    </div>
</template>